var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{attrs:{"parent":true}},[_c('div',{staticClass:"tabs"},[_c('ul',_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.index,class:[
          _vm.$route.path == '/settings/' + tab.path ||
          (tab.path != '' && _vm.$route.path.startsWith('/settings/' + tab.path))
            ? 'is-active'
            : '',
        ]},[_c('router-link',{attrs:{"to":'/settings/' + tab.path}},[_c('span',{staticClass:"icon is-small"},[_c('font-awesome-icon',{attrs:{"icon":tab.image}})],1),_c('span',[_vm._v(_vm._s(_vm.$t(tab.title)))])])],1)}),0)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }